import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src4043575844/src/nuxt/layouts/default.vue").then(m => m.default || m)),
  guest: defineAsyncComponent(() => import("/codebuild/output/src4043575844/src/nuxt/layouts/guest.vue").then(m => m.default || m))
}